import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "pleaseClick":
            return ["pleaseClick"];
    }
};
const sprite = {
    arrivalEffect1: [0, 7 + 12 / 30],
    arrivalEffect2: [8 + 23 / 30, 14 + 12 / 30],
    announcePopup: [14 + 18 / 30, 15 + 3 / 30],
    pleaseClick: [15 + 12 / 30, 16 + 17 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=video360Sound.js.map